import { render, staticRenderFns } from "./appointment-list.vue?vue&type=template&id=4c819523&scoped=true&"
import script from "./appointment-list.vue?vue&type=script&lang=js&"
export * from "./appointment-list.vue?vue&type=script&lang=js&"
import style0 from "./appointment-list.vue?vue&type=style&index=0&id=4c819523&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c819523",
  null
  
)

component.options.__file = "appointment-list.vue"
export default component.exports